// extracted by mini-css-extract-plugin
module.exports = {"modal_main":"modal_modal_main__fNx3_","modal_view":"modal_modal_view__HaJZc"};